var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIconEditProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.639,
    height: 27.642,
    viewBox: "0 0 27.639 27.642",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3854",
    "data-name": "Rectangle 3854",
    width: 27.639,
    height: 27.642,
    fill: "#111"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9307",
    "data-name": "Group 9307",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9306",
    "data-name": "Group 9306",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44113",
    "data-name": "Path 44113",
    d: "M13.827,0A13.821,13.821,0,1,1,0,13.812,13.82,13.82,0,0,1,13.827,0M1.942,13.824A11.876,11.876,0,1,0,13.821,1.943,11.865,11.865,0,0,0,1.942,13.824",
    transform: "translate(0.001 0)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44114",
    "data-name": "Path 44114",
    d: "M159.731,148.57q0-1.883,0-3.765a.965.965,0,1,1,1.925,0q0,3.78,0,7.561a.966.966,0,1,1-1.925,0q0-1.9,0-3.8",
    transform: "translate(-146.875 -132.192)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44115",
    "data-name": "Path 44115",
    d: "M157.006,94.316a1.275,1.275,0,0,1-1.283-1.273,1.286,1.286,0,1,1,2.571-.024,1.278,1.278,0,0,1-1.289,1.3",
    transform: "translate(-143.19 -84.353)",
    fill: "#111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconEditProfile);
export default __webpack_public_path__ + "static/media/info_icon_edit_profile.90c5a643808467ea28fe4282882ede60.svg";
export { ForwardRef as ReactComponent };